export { QuotesCarousel } from "./QuotesCarousel"
